import { inject } from '@angular/core';
import { Router } from '@angular/router';
import { MpsUserService } from '../services/mps-user.service';

export const MpsGuestGuard = () => {
  const router = inject(Router);
  const userService = inject(MpsUserService);

  return userService.isLoggedIn() ? router.navigateByUrl('/form') : true;
};
